module.exports = "https://static.wmbcdn.com/uniweb/images/1bf9e7c2164f5d2982a6716152cf0430.svg";